import { useEffect, useState } from "react";
import { Form, Alert } from "react-bootstrap";
import Select from "react-select";
import { Info } from "react-feather";

import ImageCapture from "../../../../components/ImageCapture";

import claimService from "../../../../services/claim.service";

const ClaimForm = ({
  claim,
  images,
  setImages,
  setClaimReasonId,
  setClaimSubReasonId,
  claimReasonNote,
  setClaimReasonNote,
  fnsku,
  setFnsku,
  removalOrderId,
  setRemovalOrderId,
  isLoading,
}) => {
  // Select states
  const [loading, setLoading] = useState(false);
  const [reasonOptions, setReasonOptions] = useState();
  const [subReasonOptions, setSubReasonOptions] = useState();
  const [selectedReasonOption, setSelectedReasonOption] = useState();
  const [selectedSubReasonOption, setSelectedSubReasonOption] = useState();

  useEffect(() => {
    const setSelectOptions = async () => {
      setLoading(true);
      const response = await claimService.getClaimReasons();

      if (response.success) {
        setReasonOptions(
          response.inspectionReportReasons.reasons.map((reason) => {
            return {
              label: reason.reason,
              value: reason.reasonId,
            };
          })
        );

        setSubReasonOptions(
          response.inspectionReportReasons.subReasons.map((subReason) => {
            return {
              claimReasonId: subReason.reasonId,
              label: subReason.subReason,
              value: subReason.subReasonId,
            };
          })
        );

        setLoading(false);
      }
    };

    if (!reasonOptions) {
      setSelectOptions();
    }
  }, []);

  useEffect(() => {
    if (claim && reasonOptions && subReasonOptions) {
      setSelectedReasonOption(
        reasonOptions.filter((option) => option.value === claim.reasonId)[0]
      );
      setSelectedSubReasonOption(
        subReasonOptions.filter(
          (option) => option.value === claim.subReasonId
        )[0]
      );
    }
  }, [reasonOptions, subReasonOptions]);

  return (
    <Form>
      <Form.Group className="mb-3">
        <Form.Label className="mb-0">
          Damage Report Reason<span className="text-danger ms-1">*</span>
        </Form.Label>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          placeholder="Select a Damage Report Reason..."
          onChange={(selectedOption) => {
            setClaimReasonId(selectedOption.value);
            setSelectedReasonOption(selectedOption);

            setClaimSubReasonId();
            setSelectedSubReasonOption(null);
          }}
          options={reasonOptions}
          value={selectedReasonOption}
          isSearchable
          isLoading={loading}
          disabled={isLoading}
        />
      </Form.Group>
      {selectedReasonOption && (
        <Form.Group className="mb-3">
          <Form.Label className="mb-0">
            Damage Report Sub Reason<span className="text-danger ms-1">*</span>
          </Form.Label>
          <Select
            className="react-select-container"
            classNamePrefix="react-select"
            placeholder="Select a Damage Report Sub Reason..."
            onChange={(selectedOption) => {
              setClaimSubReasonId(selectedOption.value);
              setSelectedSubReasonOption(selectedOption);
              setClaimReasonNote();
            }}
            options={subReasonOptions.filter(
              (option) => option.claimReasonId === selectedReasonOption.value
            )}
            value={selectedSubReasonOption}
            isSearchable
            isLoading={loading}
            disabled={isLoading}
          />
        </Form.Group>
      )}
      {selectedReasonOption &&
        selectedSubReasonOption &&
        selectedSubReasonOption.label === "Other" && (
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">
              Claim Reason Note<span className="text-danger ms-1">*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              style={{ resize: "none" }}
              placeholder="Please Describe the Claim Sub Reason..."
              onChange={(e) => {
                setClaimReasonNote(e.target.value);
              }}
              value={claimReasonNote}
              disabled={isLoading}
            />
          </Form.Group>
        )}
      {selectedReasonOption && selectedSubReasonOption && (
        <>
          <Form.Group className="mb-3">
            <Form.Label className="mb-0">FNSKU</Form.Label>
            <Form.Control
              placeholder="Enter FNSKU if available..."
              onChange={(e) => {
                setFnsku(e.target.value);
              }}
              value={fnsku}
              disabled={isLoading}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="mb-0">Removal Order Id</Form.Label>
            <Form.Control
              placeholder="Enter Removal Order Id if available..."
              onChange={(e) => {
                setRemovalOrderId(e.target.value);
              }}
              value={removalOrderId}
              disabled={isLoading}
            />
          </Form.Group>

          <Form.Label className="mb-0">
            Damage Report Images<span className="text-danger ms-1">*</span>
          </Form.Label>
          <Alert variant="info" className="flex-fill alert-blink">
            <div className="alert-icon">
              <Info
                className="position-relative top-50 start-50 translate-middle"
                size={20}
              />
            </div>
            <div className="alert-message font-weight-bold">
              Please take a clear image for each of the following:
              <div>- The item taken out of the packaging.</div>
              <div>- The LPN label.</div>
              <div>- The Serial Number on the item (if the item has one).</div>
              {selectedSubReasonOption.value === 5 && (
                <div>- The item's empty packaging.</div>
              )}
              {selectedSubReasonOption.value === 16 && (
                <div>- The Serial Number on the item's packaging.</div>
              )}
            </div>
          </Alert>
          <ImageCapture
            images={images}
            setImages={setImages}
            disabled={isLoading}
          />
        </>
      )}
    </Form>
  );
};

export default ClaimForm;
